import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { CollabDocumentContext } from '../components/CollabDocumentProvider';
export default function provideDocStatus() {
  var contextType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CollabDocumentContext;
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits(ComponentWithEditorValue, _Component);

      function ComponentWithEditorValue() {
        _classCallCheck(this, ComponentWithEditorValue);

        return _possibleConstructorReturn(this, _getPrototypeOf(ComponentWithEditorValue).apply(this, arguments));
      }

      _createClass(ComponentWithEditorValue, [{
        key: "render",
        value: function render() {
          return React.createElement(WrappedComponent, Object.assign({
            docStatus: this.context.docStatus
          }, this.props));
        }
      }]);

      return ComponentWithEditorValue;
    }(Component), _defineProperty(_class, "displayName", "provideDocStatus(".concat(WrappedComponent.displayName || WrappedComponent.name, ")")), _defineProperty(_class, "contextType", contextType), _temp;
  };
}